export default __webpack_public_path__ + "static/media/youtube.42434c97.svg";